"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PhoneHoldSmallOutlineNo = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_PhoneHoldSmallOutlineNo_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.625 1h1.312c.967 0 1.75.784 1.75 1.75v1.025c0 .464-.184.91-.512 1.238l-.918.918a.654.654 0 0 0-.15.707 7.889 7.889 0 0 0 4.255 4.256.615.615 0 0 0 .237.046.67.67 0 0 0 .47-.197l.918-.918a1.749 1.749 0 0 1 1.237-.512h1.026c.966 0 1.75.783 1.75 1.75v1.312A2.635 2.635 0 0 1 12.36 15h-.005C6.082 14.99 1 9.9 1 3.625A2.625 2.625 0 0 1 3.625 1Zm2.063 1.75a.751.751 0 0 0-.75-.75H3.624C2.73 2 2 2.73 2 3.625 2 9.336 6.646 13.99 12.357 14c.907 0 1.643-.729 1.643-1.625v-1.312a.75.75 0 0 0-.75-.75h-1.025c-.198 0-.39.08-.53.219l-.918.918c-.312.312-.741.49-1.178.49a1.61 1.61 0 0 1-.62-.122A8.94 8.94 0 0 1 4.183 7.02a1.646 1.646 0 0 1 .367-1.797l.918-.918a.745.745 0 0 0 .22-.531V2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.5a.5.5 0 0 0-1 0V6a.5.5 0 0 0 1 0V1.5ZM15 1.5a.5.5 0 0 0-1 0V6a.5.5 0 0 0 1 0V1.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_PhoneHoldSmallOutlineNo_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = PhoneHoldSmallOutlineNo;
exports["default"] = _default;